import { ApplicationListDetail } from '../../model/application/application-list-detail.model';
import { PaginableItemAdapter } from '../../../shared/components/paginable-list/paginable-item-adapter';
import { ApplicationListItemComponent } from '../application-list-item/application-list-item.component';
import { ComponentRef } from '@angular/core';
import { ItemStatus } from '../../../shared/enums/item-status.enum';
import { ApplicationList } from '../../model/application/application-list.model';

export class EnabledApplicationAdapter implements PaginableItemAdapter<ApplicationListDetail, ApplicationList, ApplicationListItemComponent> {
    getType() {
        return ApplicationListItemComponent;
    }

    setProperties(ref: ComponentRef<ApplicationListItemComponent>, item: ApplicationListDetail) {
        ref.instance.application = item;
        ref.instance.itemStatus = ItemStatus.ENABLED;
    }

    getItems(model: ApplicationList): ApplicationListDetail[] {
        if (model) {
            return model.applications;
        }
    }

    getNoDataTranslationPath(): string {
        return 'SHARED.ADAPTERS-MESSAGES.NO-APPS';
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/components/enabled-application-list/enabled-application-adapter.ts